module.exports = __webpack_public_path__ + "static/media/masthead-sound-telegraph.964a1c31.svg";